var utils = require( './utils' );
var forms = require( './forms' );

var login_popup = (function( $ ) {

	var $anchors;

	var _init = function() {
		if ( $( '#login_form' ).length > 0 ) {
			return;
		}

		var selectors = '';

		var count = 0;

		for ( var key in ScriptData.login_popup_triggers ) {
			if ( ! ScriptData.login_popup_triggers.hasOwnProperty( key ) ) {
				continue;
			}

			selectors += count > 0 ? ', ' : '';
			count++;

			selectors += ScriptData.login_popup_triggers[ key ];
		}

		$anchors = $( selectors );

		if ( $anchors.length > 0 ) {
			$anchors.on( 'click', _maybe_show_popup );
		}
	};

	var _maybe_show_popup = function( e ) {
		e.preventDefault();

		var $anchor = $( this );

		var login_redirect = $anchor.data( 'redirect' );

		if ( utils.viewport_size().width < 992 || $( this ).hasClass( 'no-popup' ) ) {
			_redirect_to_login( login_redirect );
			return;
		}

		if ( $( '#login-popup' ).length > 0 || $( '.crate-popup' ).length > 0 ) {
			_redirect_to_login( login_redirect );
			return;
		}

		var data = {
			crate_form_action: true,
			form_id: 'login_form',
			action: 'crate_get_login_popup',
			nonce: ScriptData.get_login_popup_nonce,
			redirect: login_redirect ? login_redirect : '',
			href: $anchor.attr( 'href' )
		};

		$.get( ScriptData.ajaxurl, data, _maybe_show_popup_response );
	};

	var _maybe_show_popup_response = function( response ) {
		if ( ! response.success ) {
			window.location.href = response.original_href;
		}

		var $body = $( 'body' );

		$body.append( response.html );
		$body.addClass( 'popup-open' );

		var $popup_overlay = $( '.crate-popup-overlay' );
		var $popup         = $( '#login-popup' );

		$popup_overlay.fadeIn();
		$popup.fadeIn();
		$popup.addClass( 'open' );

		$popup_overlay.on( 'click', _close_popup );
		$popup.find( 'a.close' ).on( 'click', _close_popup );

		$( '#login_form' ).each( forms.init_forms );
	};

	var _close_popup = function( e ) {
		e.preventDefault();

		$( 'body' ).removeClass( 'popup-open' );

		var $popup = $( '#login-popup' );
		var $popup_overlay = $( '.crate-popup-overlay' );

		$popup.fadeOut( 400 );
		$popup_overlay.fadeOut( 400 );

		setTimeout( function() {
			$popup.remove();
			$popup_overlay.remove();
		}, 400 );
	};

	var _redirect_to_login = function ( login_redirect ) {
		window.location.href = '/login?login_redirect=' + login_redirect;
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = login_popup;